// 获取常量类数据

import request from '@/utils/request'

// 获取年级
export const GetClassAPI = () => request.get('/users/grades/')

// 根据年级获取班级数据
export const GetBanjiAPI = (data) => request.get('/users/classes/', { params: data })

// 获取学科的数据
export const GetSubjectAPI = () => request.get('/users/subjects/')

// 获取添加教师的角色
export const GetTeaRoleAPI = () => request.get('/users/teacher_role/')

// 获取教材版本的设置
export const GetBookVerAPI = () => request.get('/resources/bookversion/')

// 学生年级升级
export const GetStuUp = () => request.get('/users/student_grade_up/')

// 获取章节单元
export const GetChapters = (data) => request.get('/resources/section/', { params: data })
